import { LitElement, html, svg } from 'lit';

export class IconDots16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Tre prikker</title><circle cx="2.4" cy="8" r="1.4" fill="currentColor"></circle><circle cx="8" cy="8" r="1.4" fill="currentColor"></circle><circle cx="13.6" cy="8" r="1.4" fill="currentColor"></circle></svg>`; }
}
if (!customElements.get('f-icon-dots16', IconDots16)) {
  customElements.define('f-icon-dots16', IconDots16);
}